import styled from 'styled-components';

export const ErrorTitle = styled.h1`
  font-size: 24px;
  font-weight: 400;
  color: red;
`;

export const ErrorDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  padding: 0;
`;
